// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3SM5A","col":"styles_col__qYRw2"};